import React from 'react';
import { career, earlierCareer } from '../../data/portfolio';
import './Experience.css';

function Experience() {
  return (
    <section id="career" className="career-section" aria-labelledby="career-title">
      <div className="section-heading">
        <p>Career</p>
        <h2 id="career-title">경력</h2>
      </div>

      <div className="career-list">
        {career.map((item) => (
          <article className="career-entry" key={item.id}>
            <div className="career-meta">
              <p className="career-period">{item.period}</p>
              <h3>{item.company}</h3>
              <p className="career-role">{item.role}</p>
            </div>
            <div className="career-description">
              <p className="career-summary">{item.summary}</p>
              <ul>
                {item.highlights.map((highlight) => <li key={highlight}>{highlight}</li>)}
              </ul>
            </div>
          </article>
        ))}
      </div>

      <div className="earlier-career">
        <h3>이전 경력</h3>
        <div className="earlier-career-list">
          {earlierCareer.map((item) => (
            <article key={item.id}>
              <p>{item.period}</p>
              <h4>{item.company}</h4>
              <span>{item.description}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
